import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const image: ThemeUICSSObject = {
  /* PREPEND HERE */
};

export default image;
